"use client";

import React from "react";
import Link from "next/link";
import { siteConfig } from "@/config/site.config";

export const EscuelaHomeTeaser: React.FC = () => {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 bg-[#020407] border-t border-gold/10 overflow-hidden">
      <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-indigo-950/20 blur-3xl rounded-full pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="border border-gold/20 rounded-2xl p-8 sm:p-12 md:p-16 bg-bg-secondary/20 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-radial from-gold/5 to-transparent blur-2xl pointer-events-none" />

          <div className="flex flex-col items-start text-left">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-[1px] bg-gold/50" />
              <span className="text-[10px] md:text-xs font-semibold tracking-[0.4em] text-gold uppercase">
                UNSAAC · Cusco
              </span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-text-pure tracking-wide font-light mb-6">
              {siteConfig.escuelaFilosofia.heroTitle}
            </h2>

            <p className="text-gold/90 text-sm sm:text-base font-light mb-6">
              {siteConfig.escuelaFilosofia.heroSubtitle}
            </p>

            <blockquote className="border-l border-gold/40 pl-6 my-2 max-w-3xl">
              <p className="text-text-muted text-sm sm:text-base font-light leading-relaxed">
                &ldquo;{siteConfig.escuelaFilosofia.compromiso}&rdquo;
              </p>
            </blockquote>

            <div className="flex flex-wrap items-center gap-4 mt-10">
              <Link
                href="/escuela-filosofia"
                className="inline-flex items-center justify-center gap-2 bg-gold text-bg-main px-8 py-3.5 font-sans font-semibold text-xs uppercase tracking-widest shadow-lg shadow-gold/20 hover:bg-gold-light hover:-translate-y-0.5 transition-all duration-300 rounded"
              >
                Participar en la Encuesta y Buzón
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>

              <span className="text-text-muted/60 text-xs font-light tracking-wide">
                100% libre, estudiantil y sin ataduras partidarias
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
